'use client';
import { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import Image from 'next/image';
import {
  getEditorColors,
  isItUndefined,
  modifyLinks,
} from '../../util/DataUtil';
import { cleanHTML } from '../utils/htmlUtils';
import { individualTemplateColor } from '../../util/ColorUtil';
import { useRouter } from 'next/router';

const CustomerWhySuperGraphic = ({
  data,
  individualPageForceBackgroundColor,
}) => {
  const sectionRef = useRef(null);
  const imageWrapperRef = useRef(null);
  const { locale } = useRouter();

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        animateImage();
        observer.disconnect();
      }
    });

    if (imageWrapperRef.current) observer.observe(imageWrapperRef.current);

    return () => observer.disconnect();
  }, []);

  const animateImage = () => {
    gsap.fromTo(
      imageWrapperRef.current,
      { scale: 0, opacity: 0 },
      {
        scale: 1,
        opacity: 1,
        duration: 1.5,
        ease: 'power2.out',
      }
    );
  };

  const items = data?.field_customer_items?.title_text_paragraph_type;
  const image = data?.field_customer_image?.[0];

  const emphasizedTextColor = getEditorColors(
    isItUndefined(data?.field_customer_title),
    isItUndefined(data?.field_customer_subtitle)
  ).filter((x) => x)[0];

  const renderItems = (items) =>
    items?.map((item, key) => (
      <div
        key={`item-${item?.field_title_p?.[0]?.value || key}-${items?.length - key}`}
        className="item"
      >
        <span className="title">{item?.field_title_p[0]?.value}</span>
        <span
          className={`text ${emphasizedTextColor || ''}`}
          dangerouslySetInnerHTML={{
            __html: cleanHTML(
              modifyLinks(item?.field_text_p[0]?.value, locale)
            ),
          }}
        />
      </div>
    ));

  return (
    <div
      ref={sectionRef}
      className="customer-why-super-graphic"
      style={{
        backgroundColor: individualTemplateColor(
          data?.field_customer_background?.[0]?.value,
          individualPageForceBackgroundColor
        ),
      }}
    >
      <div className="inner-container">
        <h2
          className={emphasizedTextColor || ''}
          dangerouslySetInnerHTML={{
            __html: cleanHTML(
              modifyLinks(data?.field_customer_title?.[0]?.value, locale)
            ),
          }}
        />
        <span
          className={`subtitle ${emphasizedTextColor || ''}`}
          dangerouslySetInnerHTML={{
            __html: cleanHTML(
              modifyLinks(data?.field_customer_subtitle?.[0]?.value, locale)
            ),
          }}
        ></span>

        <div className="bottom">
          {image && (
            <div ref={imageWrapperRef} className="image-wrapper">
              <div className="images">
                <Image
                  alt="main-image"
                  layout="fill"
                  className="main-image"
                  src={image}
                />
                <img
                  alt="overlay"
                  className="overlay"
                  src="/images/why-super-overlay.png"
                />
              </div>
            </div>
          )}
          <div className="items">{renderItems(items)}</div>
        </div>
      </div>
    </div>
  );
};

export default CustomerWhySuperGraphic;
